import { useEffect, useRef } from "react";

/**
 * Adds the `.is-visible` class to any element with `.reveal` when it scrolls into view.
 * Returns a ref to attach to a container — descendants with `.reveal` will animate in.
 */
export default function useScrollReveal() {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || typeof window === "undefined") return;
    const targets = ref.current.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return ref;
}
